import { render, staticRenderFns } from "./LabelBox.vue?vue&type=template&id=0e1a39ba&scoped=true&"
import script from "./LabelBox.vue?vue&type=script&lang=js&"
export * from "./LabelBox.vue?vue&type=script&lang=js&"
import style0 from "./LabelBox.vue?vue&type=style&index=0&id=0e1a39ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1a39ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1a39ba')) {
      api.createRecord('0e1a39ba', component.options)
    } else {
      api.reload('0e1a39ba', component.options)
    }
    module.hot.accept("./LabelBox.vue?vue&type=template&id=0e1a39ba&scoped=true&", function () {
      api.rerender('0e1a39ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/labels/LabelBox.vue"
export default component.exports